/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, pxToEmWithBaseline, replacePXinStringWithEM, centerAbsolutely, imageTypes, animations, mediaQuery, convertHexToRGB } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- USER DATA COLLECTION FAILURE PHASE STYLES --------------- ++++++++++ */
export default {
    udcfailure: {
        '& .failuremessage': {
            display: 'block',
            height: pxToEm(225),
            width: '100%',
            paddingTop: pxToEm(15),
            '& .graphic.failure': {
                backgroundColor: 'transparent',
                backgroundImage: `url(${url.image.app}/icon-submit-fail.svg )`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50%',
                backgroundSize: 'contain',
                width: '100%',
                height: pxToEm(66),
                margin: replacePXinStringWithEM('0px auto 16px'),
                // animation
                opacity: '0',
                animationName: 'rotateIn',
                animationDuration: '.3s',
                animationDelay: '.2s',
                animationFillMode: 'forwards'
            },
            '& .title': {
                // animation
                fontSize: pxToEmWithBaseline({ value: 24, fontSizeBaseline: 18 }),
                marginBottom: pxToEmWithBaseline({ value: 16, fontSizeBaseline: 21 }),
                opacity: '0',
                animationName: 'fadeInUp',
                animationDuration: '.3s',
                animationDelay: '.3s',
                animationFillMode: 'forwards'
            },
            '& .bodycopy': {
                fontSize: pxToEmWithBaseline({ value: 16, fontSizeBaseline: 14 }),
                marginBottom: pxToEmWithBaseline({ value: 24, fontSizeBaseline: 18 }),
                // animation
                opacity: '0',
                animationName: 'fadeInUp',
                animationDuration: '.4s',
                animationDelay: '.4s',
                animationFillMode: 'forwards',
                '& p': {
                    marginBottom: 0
                }
            }
        },

        '& .ctas': {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: pxToEmWithBaseline({ value: 10, fontSizeBaseline: 16 }),
            '& .button': {
                width: pxToEmWithBaseline({ value: 111, fontSizeBaseline: 14 }),
                height: pxToEmWithBaseline({ value: 32, fontSizeBaseline: 14 }),
                padding: 0,
                margin: 0,
                // animation
                transform: 'translate3d(-200%, 0, 0)', // pull off screen to start
                animationName: 'fadeInLeft',
                animationDelay: '0.3s',
                animationDuration: '.4s',
                animationFillMode: 'forwards',
                '&.white': {
                    color: `rgb(23, 60, 128)`
                }
            },
            '& .skip': {
                fontSize: pxToEmWithBaseline({ value: 14, fontSizeBaseline: 16 }),
                height: pxToEmWithBaseline({ value: 32, fontSizeBaseline: 14 }),
                width: pxToEmWithBaseline({ value: 74, fontSizeBaseline: 14 }),
                borderRadius: pxToEm(3),
                '& .skipinner': {
                    width: '100%'
                },
                '&.styletype-transparent': {
                    animationDelay: '0.3s',
                },

            }
        }
    }
};
